import api from '@/lib/api';

// ─── Response shapes (mirror apps/api/.../channels/admin-channels.service.ts) ──

export interface AdminChannelProperty {
  propertyId: string;
  name: string;
  clientName: string;
  isActive: boolean;
  hasConnection: boolean;
  connectionId: string | null;
}

export interface AdminChannelMapping {
  id: string;
  unitId: string;
  unitName: string;
  externalListingId: string;
  allotment: number;
}

export interface AdminChannelDetail {
  property: { id: string; name: string; clientName: string };
  connection: {
    id: string;
    externalPropertyId: string;
    hotelId: string;
    ratePlanIds: string[];
    poolSize: number | null;
    isActive: boolean;
  } | null;
  mappings: AdminChannelMapping[];
  units: Array<{ id: string; name: string }>;
  lastSync: { status: string; at: string } | null;
}

const BASE = '/admin/platform/channels';

export async function listChannelProperties(): Promise<AdminChannelProperty[]> {
  const { data } = await api.get<AdminChannelProperty[]>(`${BASE}/properties`);
  return data;
}

export async function getPropertyChannel(
  propertyId: string,
): Promise<AdminChannelDetail> {
  const { data } = await api.get<AdminChannelDetail>(
    `${BASE}/property/${propertyId}`,
  );
  return data;
}

export async function createChannelConnection(payload: {
  propertyId: string;
  channel: string;
  externalPropertyId: string;
  credentials?: Record<string, unknown>;
  poolSize?: number;
}) {
  const { data } = await api.post(`${BASE}/connections`, payload);
  return data;
}

export async function updateChannelConnection(
  id: string,
  payload: {
    externalPropertyId?: string;
    credentials?: Record<string, unknown>;
    poolSize?: number | null;
  },
) {
  const { data } = await api.put(`${BASE}/connections/${id}`, payload);
  return data;
}

export async function deleteChannelConnection(id: string) {
  await api.delete(`${BASE}/connections/${id}`);
}

export async function addChannelMapping(
  connectionId: string,
  payload: { unitId: string; externalListingId: string; allotment?: number },
) {
  const { data } = await api.post(
    `${BASE}/connections/${connectionId}/mappings`,
    payload,
  );
  return data;
}

export async function deleteChannelMapping(
  connectionId: string,
  mappingId: string,
) {
  await api.delete(`${BASE}/connections/${connectionId}/mappings/${mappingId}`);
}

export async function syncChannelNow(connectionId: string) {
  const { data } = await api.post(
    `${BASE}/connections/${connectionId}/sync`,
    {},
  );
  return data as { syncedUnits: number; allOk: boolean; results: unknown[] };
}
